/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = High
 *
 * 2 = Medium
 *
 * 3 = Low
 *
 * 4 = Urgent
 */
export enum MaintenanceTasksPriorityEnum {
  High = 1,
  Medium = 2,
  Low = 3,
  Urgent = 4,
}
